<form autocomplete="on" class="space-y-6" (submit)="onRecuperar($event)">
  <!-- Header -->
  <div class="text-center">
    <!-- Icon with pulse ring -->
    <div
      class="relative mx-auto flex items-center justify-center w-14 h-14 rounded-full bg-blue-500/10 border border-blue-500/20 mb-5"
    >
      <svg
        class="relative z-10 w-6 h-6 text-blue-400"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        stroke-width="2"
        aria-hidden="true"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
        />
      </svg>
      <!-- Pulse ring -->
      <span
        class="absolute inset-0 rounded-full border border-blue-400/40 animate-ping opacity-75"
      ></span>
    </div>

    <h2
      class="text-xl sm:text-2xl font-bold bg-linear-to-r from-white via-blue-100 to-cyan-200 bg-clip-text text-transparent"
    >
      Recuperar contraseña
    </h2>
    <p class="mt-2 text-sm text-slate-400 max-w-xs mx-auto leading-relaxed">
      Ingresa tu correo y te enviaremos un enlace para restablecer tu contraseña.
    </p>
  </div>
  <!-- RUC field -->
  <div class="flex flex-col gap-1.5 group">
    <label
      for="ruc"
      class="text-slate-300 text-sm group-focus-within:text-blue-400 transition-colors"
    >
      RUC
    </label>
    <input
      id="ruc"
      type="text"
      placeholder="12345678901"
      [formField]="form.ruc"
      class="w-full pl-3 pr-3 py-2.5 border border-white/10 rounded-lg bg-white/5 text-white placeholder-slate-500 focus:border-blue-400 focus:ring-2 focus:ring-blue-500/20 outline-none transition-all duration-200 text-sm"
    />
  </div>
  <!-- Email field -->
  <div class="flex flex-col gap-1.5 group">
    <label
      for="recovery-email"
      class="text-slate-300 text-sm group-focus-within:text-blue-400 transition-colors"
    >
      Correo electrónico
    </label>
    <div class="relative">
      <span
        class="absolute left-3.5 top-1/2 -translate-y-1/2 text-slate-500 group-focus-within:text-blue-400 transition-colors"
        aria-hidden="true"
      >
        <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
          />
        </svg>
      </span>
      <input
        id="recovery-email"
        type="email"
        placeholder="correo@ejemplo.com"
        [formField]="form.email"
        autocomplete="email"
        class="w-full pl-10 pr-3 py-2.5 border border-white/10 rounded-lg bg-white/5 text-white placeholder-slate-500 focus:border-blue-400 focus:ring-2 focus:ring-blue-500/20 outline-none transition-all duration-200 text-sm"
      />
    </div>
  </div>

  <!-- Success message (shown after submission) -->
  @if (mensajeFront() != null) {
    @if (mensajeFront()?.tipo == 'success') {
      <div class="rounded-xl bg-green-500/5 border border-green-500/10 p-4 backdrop-blur-sm">
        <div class="flex items-start gap-3">
          <div class="shrink-0 mt-0.5">
            <svg
              class="w-5 h-5 text-green-400"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              stroke-width="2"
              aria-hidden="true"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
          </div>
          <div>
            <p class="text-sm font-medium text-green-300 mb-1">{{ mensajeFront()?.titulo }}</p>
            <p class="text-xs text-green-400/70 leading-relaxed">
              {{ mensajeFront()?.mensaje }}
            </p>
          </div>
        </div>
      </div>
    } @else {
      <div class="rounded-xl bg-red-500/5 border border-red-500/10 p-4 backdrop-blur-sm">
        <div class="flex items-start gap-3">
          <div class="shrink-0 mt-0.5">
            <svg
              class="w-5 h-5 text-red-400"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              stroke-width="2"
              aria-hidden="true"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
          </div>
          <div>
            <p class="text-sm font-medium text-red-300 mb-1">{{ mensajeFront()?.titulo }}</p>
            <p class="text-xs text-red-400/70 leading-relaxed">
              {{ mensajeFront()?.mensaje }}
            </p>
          </div>
        </div>
      </div>
    }
  }

  <!-- Submit button -->
  <button
    type="submit"
    class="w-full py-3 bg-linear-to-r from-[#0080f3] to-[#0ea5e9] text-white font-semibold rounded-lg hover:shadow-lg hover:shadow-[#0080f3]/40 active:scale-[0.98] transition-all duration-200 text-sm"
    [hidden]="mensajeEnviado() == true"
  >
    Enviar enlace de recuperación
  </button>

  <!-- Decorative divider -->
  <div class="flex items-center gap-3">
    <div class="flex-1 h-px bg-white/5"></div>
    <span class="text-xs text-slate-600">o</span>
    <div class="flex-1 h-px bg-white/5"></div>
  </div>

  <!-- Back to login -->
  <div class="text-center">
    <a
      routerLink="/home"
      class="inline-flex items-center gap-1.5 text-sm text-blue-400 hover:text-blue-300 transition group"
    >
      <svg
        class="w-4 h-4 group-hover:-translate-x-0.5 transition-transform"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        stroke-width="2"
        aria-hidden="true"
      >
        <path stroke-linecap="round" stroke-linejoin="round" d="M15 19l-7-7 7-7" />
      </svg>
      Volver al inicio de sesión
    </a>
  </div>
</form>
